// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"117":"597275abe1547c3d","266":"f4a5393596311c74","396":"913cc8113ec27f90"}[chunkId] + ".js";
};